export const FIELDS_SCHEMA = [
  {
    key: "amount",
    label: "Amount",
    type: "number",
    readOnly: true,
  },
  {
    key: "companyName",
    label: "Company Name",
    type: "text",
    readOnly: false,
  },
  {
    key: "phone",
    label: "Phone",
    type: "text",
    readOnly: true,
  },
  {
    key: "email",
    label: "Email",
    type: "email",
    readOnly: true,
  },
  {
    key: "companyAddress",
    label: "Company Address",
    type: "text",
    readOnly: false,
  },
  {
    key: "pincode",
    label: "Pincode",
    type: "text",
    readOnly: false,
  },
  {
    key: "state",
    label: "State",
    type: "select",
    readOnly: false,
  },
  {
    key: "gstin",
    label: "GST Number",
    type: "text",
    readOnly: false,
  },
  {
    key: "hsnCode",
    label: "HSN Code",
    type: "text",
    readOnly: false,
  },
  {
    key: "gstPercentage",
    label: "GST Percentage",
    type: "number",
    readOnly: false,
  },
];

export const WORKFLOWS = {
  EINVOICE_FLOW: "EINVOICE_FLOW",
  NORMAL_FLOW: "NORMAL_FLOW",
};

export const E_INVOICE_STATUS = {
  NOT_ELIGIBLE: 1,
  SUCCESS: 2,
  FAILED: 3,
  PENDING: 4,
};

export const CUSTOMER_DETAILS_KEYS = ["phone", "email"];
export const INVOICE_DETAILS_KEYS = [
  "companyName",
  "companyAddress",
  "state",
  "pincode",
  "amount",
];
export const GST_DETAILS_KEYS = ["gstin"];

export const GST_PERCENTAGES = [0, 5, 12, 18];

export const GST_PERCENTAGE_OPTIONS = GST_PERCENTAGES.map((gst, idx) => ({
  id: `gst-${gst}-${idx}`,
  label: `${gst}%`,
  value: String(gst),
}));

export const DEFAULT_GST_HSN = {
  gst: "18",
  hsn: "998397",
};

export const BANNER_DETAILS = {
  text: "Modifying this invoice will cancel the current invoice, issue a credit note, and generate a new invoice with the updated details.",
  className: "tw-bg-yellow-50",
};

export const REFUND_OPTIONS_CUSTOM_AMOUNT = 3;

export const PENDING_INVOICE_UPDATE = "PENDING_INVOICE_UPDATE";
export const REFUND_RESPONSE_FREE = "free";
export const SET_TIMEOUT_DEFAULT = 500;
export const PHONE = "phone";
export const PINCODE = "pincode";

// Regex Validation Patterns
export const VALIDATION_REGEX = {
  NON_DIGITS: /\D/g,
  EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  PINCODE: /^[0-9]{6}$/,
  GSTIN: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/i,
};

// Validation Numerical Thresholds
export const PHONE_LENGTH_LIMITS = {
  MIN: 10,
  MAX: 15,
};

export const GST_LIMITS = {
  MIN: 0,
  MAX: 100,
};

export const DEFAULT_COUNTRY_CODE = "91";

export const CALCULATION_CONSTANTS = {
  PERCENTAGE_BASE: 100,
  ZERO_DEFAULT: 0,
  ONE: 1,
};
